import React from 'react';
import { Field } from 'react-final-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';

import RenderDropdown from 'forms/RenderDropdown';
import { validators } from 'forms';
import { DayOfTheWeekOptionsType } from 'components/DayOfTheWeekOptions/types';
import { WorksheetType } from 'services/worksheet/types';
import { makeSelectFilteredDayOfTheWeekOptions } from './selectors';

const { isRequired } = validators;

interface ConnectedProps {
    filteredOptions: DayOfTheWeekOptionsType;
}

export interface OwnProps {
    options: DayOfTheWeekOptionsType;
    worksheetType: WorksheetType;
}

export type Props = OwnProps & ConnectedProps;

export class DayOfTheWeekFieldDropdownComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { filteredOptions } = this.props;

        return (
            <Field
                component={RenderDropdown as any}
                subscription={{
                    value: true,
                    touched: true,
                    error: true
                }}
                name="dayOfTheWeek"
                label="Day of the week"
                placeholder="Select a day of the week"
                fluid
                search
                selection
                clearable
                selectOnBlur={false}
                validate={isRequired}
                options={filteredOptions}
                nullOnUnmount
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    filteredOptions: makeSelectFilteredDayOfTheWeekOptions()
});

export default connect(mapStateToProps)(DayOfTheWeekFieldDropdownComponent);
